
export class LoteListarVendasDto {
  id: number;
  label: string;
  quadra: string;
  contratosVendidosTotal: number;

  constructor(
    id: number,
    label: string,
    quadra: string,
    contratosVendidosTotal: number,
  ) {
    this.id = id;
    this.label = label;
    this.quadra = quadra;
    this.contratosVendidosTotal = contratosVendidosTotal;
  }
}
